module.exports = __webpack_public_path__ + "static/media/quote.366a72a1.png";